import Breadcrumb from "../Breadcrumb";
import * as S from "./styles";

const PageWrapper = ({ breadcrumb, children, ...rest }) => {
  const hasBreadcrumb = breadcrumb;

  return (
    <S.Wrapper hasBreadcrumb={hasBreadcrumb} {...rest}>
      {breadcrumb && <Breadcrumb {...breadcrumb} />}
      {children}
    </S.Wrapper>
  );
};

export default PageWrapper;
